/* Ines-Moda — winkelwagenlade: totaalregel bijwerken + snel toevoegen met maatkeuze */
(function () {
  'use strict';

  /* ---------- 1. SUMA gelijkhouden aan de subtotaalregel ----------
     Het thema werkt met querySelector maar één [data-subtotal] bij, dus onze
     eigen totaalregel blijft anders op de waarde van de paginalading staan. */
  function ververseTotaal() {
    /* [data-subtotal] zit sinds 14 okt op de SUMA-regel zelf, dus het thema
       werkt die rechtstreeks bij. Kopiëren is alleen nog nodig als er ooit
       weer een aparte subtotaalregel bij komt. */
    var bron = document.querySelector('#CartDrawer [data-subtotal]');
    var doel = document.querySelector('#CartDrawer .ines-total');
    if (bron && doel && bron !== doel) doel.innerHTML = bron.innerHTML;
    ververseBesparing();
  }

  /* ---------- 1a. besparing en doorgestreept totaal ----------
     Het ajax-sjabloon zet het van-totaal op .cart__items; die cijfers nemen we
     over zodat de regels ook na een hoeveelheidswijziging kloppen. */
  function ververseBesparing() {
    var bron = document.querySelector('#CartDrawer .cart__items');
    if (!bron) return;

    var van      = parseInt(bron.getAttribute('data-cart-compare'), 10);
    var subtotal = parseInt(bron.getAttribute('data-cart-subtotal'), 10);
    if (isNaN(van) || isNaN(subtotal)) return;

    var bespaart = van > subtotal;
    var rij  = document.querySelector('#CartDrawer .ines-row--save');
    var bed  = document.querySelector('#CartDrawer .ines-save');
    var was  = document.querySelector('#CartDrawer .ines-was');

    if (bed) bed.innerHTML = '-' + (bron.getAttribute('data-cart-save-money') || '');
    if (was) was.innerHTML = bron.getAttribute('data-cart-compare-money') || '';
    if (rij) rij.classList.toggle('hide', !bespaart);
    if (was) was.classList.toggle('hide', !bespaart);
  }

  function ververseBesparingLater() { setTimeout(ververseBesparing, 80); setTimeout(ververseBesparing, 400); }

  document.addEventListener('cart:updated', ververseBesparingLater);
  document.addEventListener('cart:build', ververseBesparingLater);
  document.addEventListener('DOMContentLoaded', ververseBesparing);

  /* ---------- 1c. staffelbalk ----------
     10% vanaf 2 stuks, 15% vanaf 3, 20% vanaf 4. Het aantal komt uit het
     ajax-sjabloon (data-count op .cart__items). */
  function ververseStaffel() {
    var balk = document.querySelector('#CartDrawer [data-ines-bundle]');
    if (!balk) return;

    var items = document.querySelector('#CartDrawer .cart__items');
    var n = items ? parseInt(items.getAttribute('data-count'), 10) : parseInt(balk.getAttribute('data-count'), 10);
    if (isNaN(n)) return;

    var nu = 0, volgend = 10;
    if (n >= 4)      { nu = 20; volgend = 0;  }
    else if (n === 3){ nu = 15; volgend = 20; }
    else if (n === 2){ nu = 10; volgend = 15; }

    var label = balk.querySelector('.ines-bundle__label');
    var value = balk.querySelector('.ines-bundle__value');

    /* Het bedrag komt uit de WERKELIJK toegepaste korting, niet uit een
       berekening. Staat de automatische korting uit, dan tonen we geen bedrag
       in plaats van een bedrag dat de klant niet krijgt. */
    var kortingBron = document.querySelector('#CartDrawer .cart__items');
    var kortingCent = kortingBron ? parseInt(kortingBron.getAttribute('data-bundle-discount'), 10) : 0;
    var kortingTekst = kortingBron ? kortingBron.getAttribute('data-bundle-discount-money') : '';

    /* Staat de automatische korting nog uit, dan rekenen we het bedrag zelf uit:
       percentage x artikelsubtotaal. Dat doen we hier en niet uit een attribuut,
       omdat .cart__items bij de eerste paginalading uit de sectie komt en pas
       daarna uit het ajax-sjabloon; alleen data-cart-subtotal staat er altijd op.
       Zodra de korting aan staat wint het werkelijke bedrag vanzelf. */
    if (!(kortingCent > 0) && kortingBron && nu > 0) {
      var basis = parseInt(kortingBron.getAttribute('data-cart-subtotal'), 10);
      if (basis > 0 && window.theme && theme.Currency && theme.Currency.formatMoney) {
        kortingCent = Math.round(basis * nu / 100);
        kortingTekst = theme.Currency.formatMoney(kortingCent, theme.settings.moneyFormat);
      }
    }

    if (label) {
      if (nu > 0 && kortingCent > 0 && kortingTekst) {
        label.textContent = '\u2212' + nu + '% = ' + kortingTekst;
      } else if (nu > 0) {
        label.textContent = '\u2212' + nu + '% aktywne';
      } else {
        label.textContent = 'Rabat ilo\u015bciowy';
      }
    }
    if (value) {
      value.textContent = volgend > 0 ? '+1 produkt = \u2212' + volgend + '%' : 'Najlepsza cena';
      value.classList.toggle('is-max', volgend === 0);
    }
    balk.classList.toggle('is-actief', nu > 0);

    var vul = 0;
    if (n >= 4)      vul = 100;
    else if (n === 3) vul = 66;
    else if (n === 2) vul = 33;

    var fill = balk.querySelector('.ines-bundle__fill');
    if (fill) fill.style.width = vul + '%';

    /* De pop-animatie moet opnieuw starten als een mijlpaal NU pas behaald is,
       anders speelt hij alleen bij het laden van de pagina. */
    var dots = balk.querySelectorAll('.ines-bundle__dot');
    for (var i = 0; i < dots.length; i++) {
      var behaald = n >= (i + 2);
      var had = dots[i].classList.contains('is-on');
      if (behaald && !had) {
        dots[i].classList.remove('is-on');
        void dots[i].offsetWidth;
      }
      dots[i].classList.toggle('is-on', behaald);
    }

    balk.setAttribute('data-count', n);
  }

  /* Het thema vervangt .cart__items NA het cart:updated-event, dus we lezen
     een tel later; anders staat het oude aantal er nog. Zelfde reden als bij
     het geslachtsblok hieronder. */
  function ververseStaffelLater() { setTimeout(ververseStaffel, 80); setTimeout(ververseStaffel, 400); }

  document.addEventListener('cart:updated', ververseStaffelLater);
  document.addEventListener('cart:build', ververseStaffelLater);
  document.addEventListener('DOMContentLoaded', ververseStaffel);
  /* ---------- 1b. juiste geslachtsblok tonen ----------
     De winkelwagen wordt via het ajax-sjabloon opnieuw opgehaald; daar zit een
     markering in met 'man' of 'woman', gebaseerd op de tags van de artikelen. */
  function ververseGeslacht() {
    var mark = document.querySelector('#CartDrawer .ines-cart-gender');
    if (!mark) return;
    var g = mark.getAttribute('data-gender') === 'man' ? 'man' : 'woman';
    var blokken = document.querySelectorAll('#CartDrawer .ines-upsell[data-gender="man"], #CartDrawer .ines-upsell[data-gender="woman"]');
    for (var i = 0; i < blokken.length; i++) {
      blokken[i].hidden = blokken[i].getAttribute('data-gender') !== g;
    }
  }

  document.addEventListener('cart:updated', ververseGeslacht);
  document.addEventListener('cart:build', function () { setTimeout(ververseGeslacht, 60); });
  document.addEventListener('DOMContentLoaded', ververseGeslacht);

  document.addEventListener('cart:updated', ververseTotaal);
  document.addEventListener('cart:build', function () { setTimeout(ververseTotaal, 60); });
  document.addEventListener('DOMContentLoaded', ververseTotaal);
  // vangnet: als het thema de subtotaal aanpast zonder event
  (function () {
    var bron = document.querySelector('#CartDrawer [data-subtotal]');
    if (!bron || !window.MutationObserver) return;
    new MutationObserver(ververseTotaal).observe(bron, { childList: true, characterData: true, subtree: true });
  })();


  /* ---------- 1c. dubbele SVG-id's in de betaalicoontjes voorkomen ----------
     payment_type_svg_tag levert vaste id's ("pi-blik-paint0_linear"). Onze kopie
     in de lade staat eerder in de pagina dan die van het thema en zit in een
     verborgen blok, waardoor url(#...) daarheen wees en het blik-icoon op de
     productpagina leeg bleef. We hernoemen de id's in ONZE kopie. */
  function ontdubbelBetaalIconen() {
    var svgs = document.querySelectorAll('.ines-pay svg');
    for (var i = 0; i < svgs.length; i++) {
      var svg = svgs[i];
      if (svg.getAttribute('data-ines-uniek')) continue;
      svg.setAttribute('data-ines-uniek', '1');
      var metId = svg.querySelectorAll('[id]');
      for (var j = 0; j < metId.length; j++) {
        var oud = metId[j].id;
        if (!oud) continue;
        var nieuw = 'ines-' + oud;
        metId[j].id = nieuw;
        var alles = svg.querySelectorAll('*');
        for (var k = 0; k < alles.length; k++) {
          var at = alles[k].attributes;
          for (var a = 0; a < at.length; a++) {
            if (at[a].value.indexOf('url(#' + oud + ')') > -1) {
              at[a].value = at[a].value.split('url(#' + oud + ')').join('url(#' + nieuw + ')');
            }
          }
        }
        if (svg.getAttribute('aria-labelledby') === oud) svg.setAttribute('aria-labelledby', nieuw);
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ontdubbelBetaalIconen);
  } else {
    ontdubbelBetaalIconen();
  }
  document.addEventListener('cart:build', function () { setTimeout(ontdubbelBetaalIconen, 60); });

  /* ---------- 2. Snel toevoegen ---------- */
  var cache = {};

  function haalProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); })
      .then(function (p) { cache[handle] = p; return p; });
  }

  function optieNaam(optie) {
    return (optie && optie.name ? optie.name : optie || '').toString().toLowerCase();
  }

  function maatIndex(p) {
    for (var i = 0; i < p.options.length; i++) {
      if (/rozmiar|size|taille|maat/.test(optieNaam(p.options[i]))) return i;
    }
    // geen maat-optie (bv. tassen): neem de optie met de meeste keuzes,
    // zodat de klant alsnog in de lade kan kiezen in plaats van weg te navigeren
    var beste = -1, meeste = 0;
    for (var k = 0; k < p.options.length; k++) {
      var aantal = 0, gezien = {};
      for (var v = 0; v < p.variants.length; v++) {
        var w = variantOptie(p.variants[v], k);
        if (w != null && !gezien[w]) { gezien[w] = 1; aantal++; }
      }
      if (aantal > meeste) { meeste = aantal; beste = k; }
    }
    return meeste > 1 ? beste : -1;
  }

  function variantOptie(v, i) { return [v.option1, v.option2, v.option3][i]; }

  function kleurVanFoto(p, mIdx) {
    // kleur die bij de getoonde foto hoort, anders de eerste leverbare variant
    var kIdx = mIdx === 0 ? 1 : 0;
    if (p.options.length < 2) return null;
    var hoofd = p.featured_image;
    for (var i = 0; i < p.variants.length; i++) {
      if (hoofd && p.variants[i].featured_image && p.variants[i].featured_image.src === hoofd) {
        return variantOptie(p.variants[i], kIdx);
      }
    }
    for (var j = 0; j < p.variants.length; j++) {
      if (p.variants[j].available) return variantOptie(p.variants[j], kIdx);
    }
    return variantOptie(p.variants[0], kIdx);
  }

  function toonPaneel(kaart, p) {
    var paneel = kaart.querySelector('.ines-qa__panel');
    var mIdx = maatIndex(p);
    paneel.innerHTML = '';

    if (p.variants.length === 1) { voegToe(kaart, p.variants[0].id); return; }

    if (mIdx === -1) { window.location.href = '/products/' + p.handle; return; }

    var kleur = kleurVanFoto(p, mIdx);
    var kIdx = mIdx === 0 ? 1 : 0;
    var rij = document.createElement('div');
    rij.className = 'ines-qa__maten';

    var kop = document.createElement('span');
    kop.className = 'ines-qa__kop';
    kop.textContent = 'Wybierz rozmiar';
    paneel.appendChild(kop);

    var pool = p.variants.filter(function (v) {
      return !(kleur !== null && p.options.length > 1 && variantOptie(v, kIdx) !== kleur);
    });
    if (!pool.length) pool = p.variants;   // vangnet: liever alles tonen dan een leeg paneel

    pool.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ines-qa__maat' + (v.available ? '' : ' is-uitverkocht');
      b.textContent = variantOptie(v, mIdx);
      if (!v.available) { b.disabled = true; b.title = 'Niedostępny'; }
      b.addEventListener('click', function (e) { e.preventDefault(); voegToe(kaart, v.id); });
      rij.appendChild(b);
    });

    if (rij.children.length === 1 && !rij.children[0].disabled) {
      rij.children[0].click();
      return;
    }
    paneel.appendChild(rij);
    paneel.hidden = false;
    kaart.classList.add('is-open');
  }

  function melding(kaart, tekst, fout) {
    var paneel = kaart.querySelector('.ines-qa__panel');
    paneel.innerHTML = '<span class="ines-qa__melding' + (fout ? ' is-fout' : '') + '">' + tekst + '</span>';
    paneel.hidden = false;
  }

  function voegToe(kaart, variantId) {
    var knop = kaart.querySelector('.ines-qa__btn');
    knop.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        melding(kaart, 'Dodano do koszyka');
        document.dispatchEvent(new CustomEvent('cart:build'));
        setTimeout(ververseTotaal, 120);
        setTimeout(function () {
          var p = kaart.querySelector('.ines-qa__panel');
          if (p) { p.hidden = true; p.innerHTML = ''; }
          kaart.classList.remove('is-open');
          knop.disabled = false;
        }, 1600);
      })
      .catch(function () {
        melding(kaart, 'Nie udało się dodać. Spróbuj ponownie.', true);
        knop.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    var knop = e.target.closest ? e.target.closest('.ines-qa__btn') : null;
    if (!knop) return;
    e.preventDefault();
    var kaart = knop.closest('.ines-upsell__item');
    var paneel = kaart.querySelector('.ines-qa__panel');
    if (kaart.classList.contains('is-open')) {
      paneel.hidden = true; paneel.innerHTML = ''; kaart.classList.remove('is-open'); return;
    }
    melding(kaart, 'Chwileczkę…');
    haalProduct(knop.getAttribute('data-handle'))
      .then(function (p) { toonPaneel(kaart, p); })
      .catch(function () { melding(kaart, 'Nie udało się wczytać. Spróbuj ponownie.', true); });
  });
})();
